import useEventBus from '@/natives/libs/hooks/useEventBus';
import useAsync from '@/natives/libs/hooks/useAsync';
import isMobile from '@pro/common/utils/isMobile';
import i18n from '@/natives/libs/i18n';
import api from '../api';
import getOneHikIdUrl from '@pro/common/utils/getOneHikIdUrl';
import getRoute from '@pro/common/utils/getRoute';
import { initUpgradeStrategy, isAccountNeedUpgrade } from '@pro/common/dao/upgrade-strategy.js';
import { WEB2ONEHIK_LANGUAGE_KEY } from '@pro/common/consts/web2onehik-language-key';
import { COUNTRY_OR_REGION_MAP } from '@pro/common/consts/country-or-region';
import bury from '../bury-point';
import useLoading from '@/natives/libs/hooks/useLoading';
import startInvitedEmployee from '../join-our-company';
import { clearAesKeyIv } from '@pro/common/utils/cryptoAES';

const elLogin = document.querySelector('.login');
const elRegister = document.querySelector('.login__register');
const elBottom = document.querySelector('.login__bottom');
const elMainWays = elBottom.querySelector('.login__main-ways');
const elPrimaryOneHikID = document.querySelector('.login__primary-onehikid');
const elSyscomButton = document.querySelector('.login__syscom');
const elPrimaryHPC = document.querySelector('.login__primary-hpc');
const elOtherWays = document.querySelector('.login__orther-ways');
const elOtherButtons = document.querySelector('.login__orther-buttons');
const elHpcButton = elOtherButtons.querySelector('.login__hpc');
const elAzureButton = elOtherButtons.querySelector('.login__azure');
const elGoogleButton = elOtherButtons.querySelector('.login__google');

let countryOrRegionIndex = Number(localStorage.getItem('hik_connect_pro_country'));
let azureADEnable = 1;
let googleEnable = 1;
const entryDialogCardAsync = useAsync();
const oneHikIDIframe = createOneHikIDIframe();
let route = getRoute();

localStorage.removeItem('currentSSOUrl');
function updateRegisterStatus() {
  if (countryOrRegionIndex === 32 || countryOrRegionIndex === 297) {
    elRegister.remove();
  } else {
    elLogin.insertBefore(elRegister, elLogin.children[0]);
  }
}
/**
 * 防抖，用于解决刷新落地页时的按钮多次刷新。
 *
 * @param {Function} func - 需要被防抖的函数。
 * @param {Number} wait - 等待时间，单位为毫秒，默认值为100毫秒。
 * @return {Function} 返回一个新的函数，这个函数在调用时会延迟执行原函数，如果在等待时间内再次调用，则会重新计时。
 */
function debounce(func, wait = 100) {
  let timeout;
  return function () {
    const context = this;
    const args = arguments;
    clearTimeout(timeout);
    timeout = setTimeout(function () {
      func.apply(context, args);
    }, wait);
  };
}
const updateButtonsStatus = debounce(function () {
  const switchPrimaryToOneHikID = () => {
    elPrimaryHPC.remove();
    // elBottom.insertBefore(elPrimaryOneHikID, elBottom.children[0]);
    elMainWays.insertBefore(elPrimaryOneHikID, elMainWays.children[0]);
  };

  const switchPrimaryToHPC = () => {
    elPrimaryOneHikID.remove();
    elPrimaryHPC.style.removeProperty('display');
    // elBottom.insertBefore(elPrimaryHPC, elBottom.children[0]);
    elMainWays.insertBefore(elPrimaryHPC, elMainWays.children[0]);
  };

  // 从这一次之前提交的 common\consts\upgrade-strategy.js 来看，NowupgradeDate 始终为 true
  const NowupgradeDate = isAccountNeedUpgrade(countryOrRegionIndex) > 0;

  if (countryOrRegionIndex !== 143 && !NowupgradeDate) {
    elOtherWays.remove();
    elSyscomButton.remove();
    switchPrimaryToHPC();
  } else {
    if (NowupgradeDate) {
      switchPrimaryToOneHikID();
    } else {
      switchPrimaryToHPC();
    }
    elBottom.appendChild(elOtherWays);
    if (NowupgradeDate) {
      const spanElement = elOtherButtons.querySelector('span');
      elOtherButtons.insertBefore(elHpcButton, spanElement.nextSibling);
      // elOtherButtons.insertBefore(elHpcButton, elOtherButtons.children[0]);
    } else {
      elHpcButton.remove();
    }
    if (countryOrRegionIndex === 143) {
      elSyscomButton.style.removeProperty('display');
      // elOtherButtons.appendChild(elSyscomButton);
      elMainWays.appendChild(elSyscomButton);
    } else {
      elSyscomButton.remove();
    }
  }
  // 初始化azureAD 和 google workspace灰度
  api
    .initAzureGrayscale({
      functionKeys: ['AZURE_AD', 'GOOGLE_WORKSPACE'],
      countryCode: countryOrRegionIndex,
      productId: 1,
      clientSource: process.env.clientSource
    })
    .then((response) => {
      const getStatusByKey = (key) =>
        response?.[0]?.grayScaleList.find(item => item.functionKey === key)?.status;

      azureADEnable = getStatusByKey('AZURE_AD');
      googleEnable = getStatusByKey('GOOGLE_WORKSPACE');

      // 根据状态更新按钮显示
      const shouldShowAzure = azureADEnable === 0;
      const shouldShowGoogle = googleEnable === 0;
      updateButtonVisibility(elAzureButton, shouldShowAzure);
      updateButtonVisibility(elGoogleButton, shouldShowGoogle);
    })
    .catch(console.error);
}, 50);

function updateButtonVisibility(buttonElement, shouldShow) {
  if (shouldShow) {
    buttonElement.style.removeProperty('display');
    // elBottom.appendChild(buttonElement);
    elOtherButtons.appendChild(buttonElement);
  } else {
    buttonElement.remove();
  }
}

function createOneHikIDIframe() {
  const iframe = document.createElement('iframe');
  iframe.referrerPolicy = 'no-referrer';
  iframe.allow = 'cross-origin-isolated; geolocation *';
  iframe.style.position = 'fixed';
  iframe.style.width = '100%';
  iframe.style.height = '100%';
  iframe.style.border = 'none';
  iframe.style.top = 0;
  iframe.style.left = 0;
  iframe.style.zIndex = 2000;
  iframe.style.background = '#fff';

  // let loading;
  // iframe.addEventListener('load', () => {
  //   loading?.close();
  // });
  return {
    open: (url) => {
      // 2.16.0 不再使用iframe打开sso
      window.location.href = url;
      // if (process.env.mode === 'dev') {
      //   window.location.href = url;
      //   return;
      // }
      // if (isMobile()) {
      //   window.location.href = url;
      //   return;
      // }
      // // loading = useLoading();
      // document.body.style.overflow = 'hidden';
      // iframe.src = url;
      // document.body.appendChild(iframe);
    },
    close: () => {
      document.body.style.overflow = 'auto';
      iframe.remove();
    }
  };
}

async function openOneHikIDPage(urlType = 'login') {
  const invitedEmail = sessionStorage.getItem('invitedEmail'); //邀请员工URL invitedEmail
  const invitedName = sessionStorage.getItem('invitedName'); //邀请员工URL invitedName
  const invitedType = sessionStorage.getItem('invitedType'); //邀请员工URL invitedType
  const invitedCountry = parseInt(sessionStorage.getItem('invitedCountry'), 10); //邀请员工URL invitedCountry

  const lastEmail
    = (invitedEmail ? `${invitedEmail}&emailEditable=false` : null)
    || (urlType === 'login' ? localStorage.getItem('hik_connect_pro_last_oneHikId_email') : '');
  const lastPhoneAndAreaCode = urlType === 'login' ? localStorage.getItem('hik_connect_pro_last_login_phone') : '';
  const phoneAreaCode = lastPhoneAndAreaCode ? lastPhoneAndAreaCode.split('-')[0] : '';
  const lastPhone = lastPhoneAndAreaCode ? lastPhoneAndAreaCode.split('-')[1] : '';
  let ssoDomain = '';
  try {
    let [data] = await api.getSSODomain();
    if (data && data.domain) {
      ssoDomain = removeAllPortsFromUrl(data.domain);
      localStorage.setItem('currentSSOUrl', ssoDomain);
    } else {
      ssoDomain = '';
    }
  } catch (error) {
    ssoDomain = '';
  }
  const oneHikIdLoginUrl = `${ssoDomain ? (ssoDomain.endsWith('/') ? ssoDomain : `${ssoDomain}/`) : getOneHikIdUrl()}${urlType}`;
  const type
    = urlType === 'login'
      ? '&typeList=4,6,1,2,10,8,7'
      : sessionStorage.getItem('register-onehikid-type')
        ? `&type=${sessionStorage.getItem('register-onehikid-type')}&typeEditable=false`
        : '';
  let cbService = window.location.origin + encodeURIComponent(`/#/ticketJump/${invitedEmail ? 'invited' : urlType}`);
  let registerService = window.location.origin + encodeURIComponent(`/#/Register`);
  const countryOrRegionInfo = COUNTRY_OR_REGION_MAP[invitedCountry] || COUNTRY_OR_REGION_MAP[countryOrRegionIndex];
  const countryOrRegionCode = countryOrRegionInfo.countryCode;
  const locale = WEB2ONEHIK_LANGUAGE_KEY[i18n.locale] || i18n.locale;
  const querys = [
    `service=${cbService}`,
    `plateFormType=9${type}`,
    `${urlType === 'login' || urlType === 'register' ? 'showAutoLogin=true' : ''}`,
    `countryEditable=false`,
    `country=${countryOrRegionCode}`,
    `locale=${locale}`,
    `${lastEmail ? `email=${lastEmail}` : ''}`,
    `${lastPhoneAndAreaCode
      ? `phone=${lastPhone}&areaCode=${encodeURIComponent('+')}${phoneAreaCode}&phoneEditable=true`
      : ''
    }`,
    `${invitedType ? `typeEditable=false&type=${invitedType}` : ''}`,
    `${invitedName ? `companyEditable=false&company=${invitedName}` : ''}`,
    `regUrl=${registerService}`
  ].filter((item) => !!item);
  const url = `${oneHikIdLoginUrl}?${querys.join('&')}`;
  sessionStorage.removeItem('register-onehikid-type');
  // 如果是从工单跳转过来，需要通过sessionStorage保存工单参数
  if (route.query.from === 'support') {
    const caseId = route.query.caseId;
    sessionStorage.setItem('from-support', JSON.stringify({ caseId }));
  }
  oneHikIDIframe.open(url);
}

function removeAllPortsFromUrl(url) {
  try {
    const urlObj = new URL(url);
    urlObj.port = ''; // 直接清空端口
    return urlObj.origin.toString();
  } catch (e) {
    console.error('Invalid URL:', e);
    return url;
  }
}

function closeOneHikIDPage() {
  oneHikIDIframe.close();
}

function openSyscomPage() {
  if (document.referrer.indexOf('support') > -1) {
    localStorage.setItem('hik_connect_pro_go_support', 1);
  }

  window.location.href
    // 取自 sub_apps\hik-proconnect\public\config\third_jump.json
    = `https://www.syscom.mx/principal/hikproconnect_auth?cB=${encodeURIComponent(`${window.location.origin}/#/thirdJump/`)
    }${countryOrRegionIndex}`;
}

function openReset() {
  console.log('openReset');
}

async function openChooseId(e, isForceOld) {
  // 检测使用onehikid注册还是使用hpc注册
  const upgradeStrategy = isAccountNeedUpgrade(countryOrRegionIndex);
  if (upgradeStrategy > 0 && !isForceOld) {
    window.location.href = `${window.location.origin}/#/Register`;
  } else {
    const loading = useLoading(elLogin);
    const entryDialogCard = await entryDialogCardAsync.get();
    loading.close();
    bury.loginEvent(2); //新登录页-注册
    bury.registerClick(1); //admin注册弹窗（HPC注册）-点击注册-新首页右上角-注册
    entryDialogCard.instance.open('chooseId');
  }
}

async function toRegister(type, autoEmail) {
  if (type === 'onehikid') {
    // window.location.href = `${window.location.origin}/#/Register`;
    window.location.hash = '#/onehikid/register';
  } else if (type === 'hpc') {
    const loading = useLoading(elLogin);
    const entryDialogCard = await entryDialogCardAsync.get();
    loading.close();

    entryDialogCard.instance.open('register', { autoEmail });
  }
}

async function toLogin(type, autoEmail) {
  if (sessionStorage) {
    sessionStorage.removeItem('upgradeOriginType'); //登出删除syscom临时判断标识
  }
  if (type === 'onehikid') {
    bury.oneHikIDLogin(1, 1);
    sessionStorage.removeItem('updated_onehik');
    window.location.hash = '#/onehikid/login';
  } else if (type === 'hpc') {
    const loading = useLoading(elLogin);
    const entryDialogCard = await entryDialogCardAsync.get();
    loading.close();

    bury.loginDialog(1, 5);
    sessionStorage.removeItem('updated_onehik');
    bury.loginDialog(2);
    entryDialogCard.instance.open('login', {
      canRegister: countryOrRegionIndex !== 32 && countryOrRegionIndex !== 297,
      autoEmail
    });
  } else if (type === 'syscom') {
    openSyscomPage();
  } else if (type === 'azure' || type === 'google') {
    const loading = useLoading(elLogin);
    const entryDialogCard = await entryDialogCardAsync.get();
    loading.close();
    entryDialogCard.instance._data.azureLoginShow = true;
    if (type === 'google') {
      entryDialogCard.instance._data.googleLoginShow = true;
    }
  }
}

/**
 * 根据url传参决定初始化完成后要做的事情
 */
function autoAction() {
  route = getRoute();
  console.log('route.path', route.path);
  if (route.path === '/onehikid/login') {
    openOneHikIDPage('login');
  } else if (route.path === '/onehikid/register') {
    openOneHikIDPage('register');
  } else {
    closeOneHikIDPage();
  }

  if (route.path === '/onehikid' && route.query.url) {
    const url = atob(route.query.url);
    // 判断一下是否是Onehikid的域名，避免将其它网站嵌入iframe中打开
    if (url.startsWith(getOneHikIdUrl())) {
      oneHikIDIframe.open(url);
    }
  }

  if (route.query.inviteFriend) {
    //邀请法人注册也使用老的注册方式
    openChooseId(null, true);
  }

  // 邮件进入首页的埋点
  // ??? 仅仅只是埋点 ？？？
  if (route.query.email) {
    bury.getEmailJumpToHomePage();
  }

  if (route.query.dialogType) {
    ({
      login: () => toLogin('hpc', route.query.autoEmail),
      register: () => toRegister('hpc', route.query.autoEmail),
      chooseId: openChooseId,
      reset: openReset
    })[route.query.dialogType]?.();
  }

  if (sessionStorage.getItem('SSO_admin_to_login')) {
    sessionStorage.removeItem('SSO_admin_to_login');
    toLogin('onehikid');
  }
  if (route.query.openOneHikIDLogin) {
    toLogin('onehikid');
  }

  // hpc注册相关，从原loginComponents迁移过来，逻辑貌似有问题
  const inviteAccount = sessionStorage.getItem('inviteAccount');
  if (inviteAccount) {
    openChooseId();
    sessionStorage.removeItem('inviteAccount');
  }

  // Explore跳转登录
  if (route.query.act === 'login') {
    toLogin('onehikid');
  }
  if (route.query.act === 'register') {
    openChooseId();
  }
}

function initVueComponents(comp) {
  entryDialogCardAsync.set(comp);
  const el = document.querySelector('.login__dialogs');
  comp.init(el, {
    mixins: {
      methods: {
        // $t: i18n.t.bind(i18n),
        toRegister,
        toLogin,
        getCountryOrRegionIndex: () => countryOrRegionIndex
      }
    },
    i18n,
    api,
    buryPoint: bury
  });
}

function bindEvent() {
  const countryOrRegionChange = useEventBus('country-or-region-change');
  countryOrRegionChange.on((index) => {
    countryOrRegionIndex = index;
    updateRegisterStatus();
    updateButtonsStatus();
  });
  const entryDialogCardLoad = useEventBus('entry-dialog-card-load');
  if (entryDialogCardLoad.ComponentsVue) {
    initVueComponents(entryDialogCardLoad.ComponentsVue);
    console.log(`output->entryDialogCardLoad.ComponentsVue)`, entryDialogCardLoad.ComponentsVue);
    delete entryDialogCardLoad.ComponentsVue;
  } else {
    entryDialogCardLoad.once((val) => {
      initVueComponents(val);
      delete entryDialogCardLoad.ComponentsVue;
    });
  }
  const toLoginEvent = useEventBus('to-login');
  toLoginEvent.on(toLogin);
  const toRegisterEvent = useEventBus('to-register');
  toRegisterEvent.on(toRegister);
  const upgradeStrategyUpdate = useEventBus('upgrade-strategy-update');
  upgradeStrategyUpdate.on(() => {
    updateRegisterStatus();
    updateButtonsStatus();
  });
  elRegister.addEventListener('click', openChooseId);
  elPrimaryOneHikID.addEventListener('click', () => toLogin('onehikid'));
  elPrimaryHPC.addEventListener('click', () => toLogin('hpc'));
  elHpcButton.addEventListener('click', () => toLogin('hpc'));
  elSyscomButton.addEventListener('click', () => toLogin('syscom'));
  elAzureButton.addEventListener('click', () => toLogin('azure'));
  elGoogleButton.addEventListener('click', () => toLogin('google'));
  window.addEventListener('hashchange', autoAction);
}

async function getRsaKeyFunc() {
  const [rsaData] = await api.getRsaPublicKey();
  if (rsaData && rsaData.publicKey) {
    sessionStorage.setItem('rsa-public-key', JSON.stringify(rsaData));
  }
}
/**
 * mounted
 */
(function () {
  if (isMobile()) {
    // 手机上打开邀请好友和邀请员工链接，不进入到app下载页
    if (!route.query.inviteFriend && !route.query.company) {
      window.location.href = `${window.location.origin}/app/index.html`;
    }
  }
  // ep页面无游客模式
  localStorage.setItem('hik_connect_pro_tourist_Mode', false);
  // 关闭全屏蒙版
  localStorage.removeItem('oneHikId-loading-flag');
  // 每次进入登录页都清除aes秘钥和向量
  clearAesKeyIv();
  // 新增：获取CDN配置信息
  (async function () {
    try {
      const [data] = await api.getCDNUrl();
      if (data) {
        localStorage.setItem('need-change-server-key', JSON.stringify(data));
      } else {
        localStorage.removeItem('need-change-server-key');
      }
    } catch (error) {
      localStorage.removeItem('need-change-server-key');
    }
  })();
  // 获取rsa公钥
  getRsaKeyFunc();
  // 初始化国家策略
  initUpgradeStrategy();
  api
    .getAllUpgradeStrategy()
    .then((response) => {
      initUpgradeStrategy(response?.[0]?.countryStrategyList);
      const upgradeStrategyUpdate = useEventBus('upgrade-strategy-update');
      upgradeStrategyUpdate.emit();

      // 如果是邀请员工跳转到登录页，主动弹出onehikid注册窗口
      if (route.query.company) {
        startInvitedEmployee();
      }
    })
    .catch(console.error);
  updateRegisterStatus();
  updateButtonsStatus();
  bindEvent();
  autoAction();
})();
